const MSGS = {
  MARK_AS_UNREAD: "MARK_AS_UNREAD",
  MARK_AS_UNREAD_HTTP_SUCCESS: "MARK_AS_UNREAD_HTTP_SUCCESS",
  MARK_AS_DUPLICATE: "MARK_AS_DUPLICATE",
  MARK_AS_DUPLICATE_HTTP_SUCCESS: "MARK_AS_DUPLICATE_HTTP_SUCCESS",
  ADD_TO_FAVOURITES: "ADD_TO_FAVOURITES",
  ADD_TO_FAVOURITES_HTTP_SUCCESS: "ADD_TO_FAVOURITES_HTTP_SUCCESS",
  REMOVE_FROM_FAVOURITES: "REMOVE_FROM_FAVOURITES",
  REMOVE_FROM_FAVOURITES_HTTP_SUCCESS: "REMOVE_FROM_FAVOURITES_HTTP_SUCCESS",
  HTTP_ERROR: "HTTP_ERROR",
  CLEAR_ERROR: "CLEAR_ERROR",
};

export function markAsUnreadMsg({ id, unreadLink }) {
  return {
    type: MSGS.MARK_AS_UNREAD,
    id,
    unreadLink,
  };
}

export function markAsDuplicateMsg({ id, duplicateLink }) {
  return {
    type: MSGS.MARK_AS_DUPLICATE,
    id,
    duplicateLink,
  };
}

function markAsUnreadHttpSuccessMsg({ id }) {
  const responseHandler = () => ({
    type: MSGS.MARK_AS_UNREAD_HTTP_SUCCESS,
    id,
  });
  return responseHandler;
}

function markAsDuplicateHttpSuccessMsg({ id }) {
  return () => ({
    type: MSGS.MARK_AS_DUPLICATE_HTTP_SUCCESS,
    id,
  });
}

export function removeFromFavouritesMsg({ id, createActionLink }) {
  return {
    type: MSGS.REMOVE_FROM_FAVOURITES,
    id,
    createActionLink,
  };
}

function removeFromFavouritesHttpSuccessMsg({ id }) {
  return () => ({
    type: MSGS.REMOVE_FROM_FAVOURITES_HTTP_SUCCESS,
    id,
  });
}

export function addToFavouritesMsg({ id, createActionLink }) {
  return {
    type: MSGS.ADD_TO_FAVOURITES,
    id,
    createActionLink,
  };
}

function addToFavouritesHttpSuccessMsg({ id }) {
  return () => ({
    type: MSGS.ADD_TO_FAVOURITES_HTTP_SUCCESS,
    id,
  });
}

function httpErrorMsg(error) {
  return {
    type: MSGS.HTTP_ERROR,
    error,
  };
}

export const clearErrorMsg = {
  type: MSGS.CLEAR_ERROR,
};

function markAsUnreadUpdater(msg, model) {
  const { id, unreadLink } = msg;
  return {
    ...model,
    updating: true,
    command: {
      request: {
        method: "put",
        url: unreadLink,
      },
      successMsg: markAsUnreadHttpSuccessMsg({ id }),
      errorMsg: httpErrorMsg,
    },
  };
}

function markAsUnreadHttpSuccessUpdater(msg, model) {
  const { id } = msg;
  const { applications } = model;
  const newApplications = applications.map((application) =>
    application.id === id
      ? Object.assign({}, application, { unread: true })
      : application
  );
  return {
    ...model,
    updating: false,
    applications: newApplications,
    command: null,
  };
}

function markAsDuplicateUpdater(msg, model) {
  const { id, duplicateLink } = msg;
  return {
    ...model,
    updating: true,
    command: {
      request: {
        method: "put",
        url: duplicateLink,
      },
      successMsg: markAsDuplicateHttpSuccessMsg({ id }),
      errorMsg: httpErrorMsg,
    },
  };
}

function markAsDuplicateHttpSuccessUpdater(msg, model) {
  const { id } = msg;
  const { columns } = model;
  const newColumns = columns
    .map(({ cardIds, ...rest }) =>
      cardIds.includes(id)
        ? {
            cardIds: cardIds.filter((cardId) => cardId !== id),
            ...rest,
          }
        : { cardIds, ...rest }
    )
    .map(({ cardIds, columnId, title }) =>
      columnId === "rejected-candidates"
        ? { cardIds: [id, ...cardIds], columnId, title }
        : { cardIds, columnId, title }
    );
  return {
    ...model,
    columns: newColumns,
    command: null,
    updating: false,
  };
}

function addToFavouritesUpdater(msg, model) {
  const { id, createActionLink } = msg;
  const command = {
    request: {
      method: "post",
      url: createActionLink,
      data: {
        status: "added_to_favourites",
      },
    },
    successMsg: addToFavouritesHttpSuccessMsg({ id }),
    errorMsg: httpErrorMsg,
  };

  return {
    ...model,
    command,
    updating: true,
  };
}

function addToFavouritesHttpSuccessUpdater(msg, model) {
  const { id } = msg;
  const { applications } = model;
  const newApplications = applications.map((application) =>
    application.id === id
      ? Object.assign({}, application, {
          status: "added_to_favourites",
          unread: false,
        })
      : application
  );
  return {
    ...model,
    applications: newApplications,
    command: null,
    updating: false,
  };
}

function removeFromFavouritesUpdater(msg, model) {
  const { id, createActionLink } = msg;
  const command = {
    request: {
      method: "post",
      url: createActionLink,
      data: {
        status: "pending",
      },
    },
    successMsg: removeFromFavouritesHttpSuccessMsg({ id }),
    errorMsg: httpErrorMsg,
  };

  return {
    ...model,
    command,
    updating: true,
  };
}

function removeFromFavouritesHttpSuccessUpdater(msg, model) {
  const { id } = msg;
  const { applications } = model;
  const newApplications = applications.map((application) =>
    application.id === id
      ? Object.assign({}, application, { status: null })
      : application
  );
  return {
    ...model,
    updating: false,
    applications: newApplications,
    command: null,
  };
}

function httpErrorUpdater(msg, model) {
  const { error } = msg;
  return {
    ...model,
    updating: false,
    error: error.message,
  };
}

function clearErrorUpdater(msg, model) {
  return { ...model, error: null };
}

export default function update(msg, model) {
  switch (msg.type) {
    case MSGS.MARK_AS_UNREAD: {
      return markAsUnreadUpdater(msg, model);
    }
    case MSGS.MARK_AS_UNREAD_HTTP_SUCCESS: {
      return markAsUnreadHttpSuccessUpdater(msg, model);
    }
    case MSGS.MARK_AS_DUPLICATE: {
      return markAsDuplicateUpdater(msg, model);
    }
    case MSGS.MARK_AS_DUPLICATE_HTTP_SUCCESS: {
      return markAsDuplicateHttpSuccessUpdater(msg, model);
    }
    case MSGS.ADD_TO_FAVOURITES: {
      return addToFavouritesUpdater(msg, model);
    }
    case MSGS.ADD_TO_FAVOURITES_HTTP_SUCCESS: {
      return addToFavouritesHttpSuccessUpdater(msg, model);
    }
    case MSGS.REMOVE_FROM_FAVOURITES: {
      return removeFromFavouritesUpdater(msg, model);
    }
    case MSGS.REMOVE_FROM_FAVOURITES_HTTP_SUCCESS: {
      return removeFromFavouritesHttpSuccessUpdater(msg, model);
    }
    case MSGS.HTTP_ERROR: {
      return httpErrorUpdater(msg, model);
    }
    case MSGS.CLEAR_ERROR: {
      return clearErrorUpdater(msg, model);
    }
    default:
      return model;
  }
}
